export default __webpack_public_path__ + "static/media/sticker-b.d21a7706.png";